import { render, staticRenderFns } from "./LoadingProcess.vue?vue&type=template&id=79175492"
import script from "./LoadingProcess.vue?vue&type=script&lang=js"
export * from "./LoadingProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports